<template>
  <div>
    <el-dropdown @command="handleClick">
      <el-button>
        导出<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="a">常规导出</el-dropdown-item>
        <el-dropdown-item command="b">导出当前页</el-dropdown-item>
<!--        <el-dropdown-item command="c" v-if="pageType === 'jyWaybillList'">批量导入模板导出</el-dropdown-item>-->
<!--        <el-dropdown-item command="d" v-if="pageType === 'jyWaybillList' || 'jyLoadingList'===pageType">批量修改模板导出</el-dropdown-item>-->
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import { Message } from "element-ui";

export default {
  name: "ExportTb",
  props: {
    theadData: {
      type: Array,
      default: () => []
    },
    resultData: {
      //注意父组件要有 onHeaderInputSearch 这个方法
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    pageType: {
      type: String,
      default: ''
    },
  },
  methods: {
    // 导出按钮
    handleClick(e) {
      if (e === "a") {
        this.$emit("handleExportDia_dc");
      } else if (e === "b") {
        let headers = [];
        let field = [];

        this.theadData.forEach((item) => {
          if (item.isShow === 1) {
            headers.push(item.fieldNameShow || item.name);
            field.push(item.fieldAlias || item.field);
          }
        });
        let tbList =
            (this.resultData.length > 0 ? this.resultData : this.tableData) || [];
        if (!tbList || tbList.length == 0) {
          Message({
            message: "表格没有数据哦",
            type: "error",
          });
          return false;
        }
        let Data = {
          tableData: JSON.parse(JSON.stringify(tbList)),
          headers: headers,
          field: field,
        };
        this.toExcel(Data);
      } else if (e === "c") {
        this.$emit("handleExportDia_dc_import_add");
      } else if (e === "d") {
        this.$emit("handleExportDia_dc_import_update");
      }
    },
    // 导出
    async toExcel(Data) {
      // headers==表头文字  field==表头字段
      let { tableData = [], headers = [], field = [] } = Data;

      // 每行数据
      const data = tableData.map((row) => {
        let arrays = [];
        field.forEach((itemB) => {
          arrays.push(row[itemB] || "");
        });
        return arrays;
      });

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };

      // 设置表头的边框样式
      headerRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      data.forEach((rowData) => {
        worksheet.addRow(rowData);
      });

      // 遍历所有行并为每个单元格设置边框样式
      worksheet.eachRow({ includeEmpty: true }, (row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      // 设置列宽
      worksheet.columns.forEach((column, index) => {
        column.width = 13; // 设置每列宽度为 13
      });

      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        let fn = (this.$route.meta.title || "导出结果") + ".xlsx";
        // 需要引入 file-saver
        FileSaver.saveAs(blob, fn);
      });
    }
  }
};
</script>

<style scoped lang='scss'></style>
